import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { $orgUsageData } from '@nx-frontend/shared/store/org-usage';
import { $clientsDisabled, $draftInviteCount } from './store';

export function ManageMembersSeatsCount() {
  const t = useTranslations('features');
  const [orgUsage, draftInviteCount, clientsDisabled] = useUnit([$orgUsageData, $draftInviteCount, $clientsDisabled]);
  const membersCurrent = orgUsage.members.current + draftInviteCount.member + draftInviteCount.manager;
  const membersMax = orgUsage.members.max;
  const membersLimit = membersCurrent > membersMax;

  const clientsCurrent = orgUsage.clients.current + draftInviteCount.client;
  const clientsMax = orgUsage.clients.max;
  const clientsLimit = clientsCurrent > clientsMax;
  const isClientsUnlimited = clientsMax >= 10000;

  return (
    <div className="flex gap-2">
      <span
        className={classNames('text-[10px] leading-3', {
          'text-neutral-500': !membersLimit,
          'text-rose-500': membersLimit,
          'text-yellow-400': membersCurrent === membersMax,
        })}
      >
        {membersCurrent}/{membersMax} {t('manage-members.available_seats')}
      </span>
      {!clientsDisabled && (
        <span
          className={classNames('text-[10px] leading-3', {
            'text-neutral-500': !clientsLimit,
            'text-rose-500': clientsLimit,
            'text-yellow-400': clientsCurrent === clientsMax,
          })}
        >
          {!isClientsUnlimited && (
            <span>
              {clientsCurrent}/{clientsMax} {t('manage-members.available_client_seats')}
            </span>
          )}
        </span>
      )}
    </div>
  );
}
